import React, { useState, useMemo } from "react";
import Input from "../../../Elements/Input/Input";
import Button from "../../../Elements/Button/Button";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/es";

export default function EditIncapacidades({ values, handleChange }) {
  const incapacidades = useMemo(() => values.incapacidades || [], [values.incapacidades]);
  const [newIncap, setNewIncap] = useState({ motivo: "", fechaInicio: "", fechaFin: "", folioIMSS: "" });
  const [showCal, setShowCal] = useState(false);
  const [editing, setEditing] = useState(null); // { id, motivo, fechaInicio, fechaFin, folioIMSS }

  // Eventos para FullCalendar
  const events = useMemo(
    () =>
      incapacidades.map((inc) => ({
        id: inc.id,
        title: inc.motivo || "Incapacidad",
        start: inc.fechaInicio,
        end: inc.fechaFin,
        allDay: true,
        extendedProps: { ...inc },
      })),
    [incapacidades]
  );

  // Validaciones
  const canAdd =
    newIncap.motivo.trim() !== "" &&
    newIncap.fechaInicio !== "" &&
    newIncap.fechaFin !== "" &&
    newIncap.folioIMSS.trim() !== "";
  const canSave =
    editing &&
    editing.motivo.trim() !== "" &&
    editing.fechaInicio !== "" &&
    editing.fechaFin !== "" &&
    editing.folioIMSS.trim() !== "";

  // Agregar nueva incapacidad
  const handleAdd = () => {
    if (!canAdd) return;
    const id = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const lista = [
      ...incapacidades,
      { ...newIncap, id }
    ];
    handleChange("incapacidades")({ target: { value: lista } });
    setNewIncap({ motivo: "", fechaInicio: "", fechaFin: "", folioIMSS: "" });
  };

  // Click evento calendario
  const handleEventClick = ({ event }) => {
    const { id, motivo, fechaInicio, fechaFin, folioIMSS } = event.extendedProps;
    setEditing({ id, motivo, fechaInicio, fechaFin, folioIMSS });
    setShowCal(false);
  };

  // Cambios en modal edición
  const handleEditChange = (field) => (e) =>
    setEditing({ ...editing, [field]: e.target.value });

  // Guardar edición
  const saveEdit = () => {
    if (!canSave) return;
    const updated = incapacidades.map((inc) =>
      inc.id === editing.id
        ? { ...editing }
        : inc
    );
    handleChange("incapacidades")({ target: { value: updated } });
    setEditing(null);
  };

  return (
    <div className="seccion-formulario">
      <h4>Incapacidades</h4>

      {/* Formulario de nueva incapacidad */}
      <div className="row g-3 align-items-end">
        <div className="col-md-6">
          <Input
            label="Motivo"
            value={newIncap.motivo}
            onChange={(e) => setNewIncap({ ...newIncap, motivo: e.target.value })}
          />
        </div>
        <div className="col-md-6">
          <Input
            type="date"
            label="Fecha inicio"
            value={newIncap.fechaInicio}
            onChange={(e) => setNewIncap({ ...newIncap, fechaInicio: e.target.value })}
          />
        </div>
        <div className="col-md-6">
          <Input
            type="date"
            label="Fecha fin"
            value={newIncap.fechaFin}
            onChange={(e) => setNewIncap({ ...newIncap, fechaFin: e.target.value })}
          />
        </div>
        <div className="col-md-6">
          <Input
            label="Folio IMSS"
            value={newIncap.folioIMSS}
            onChange={(e) => setNewIncap({ ...newIncap, folioIMSS: e.target.value })}
          />
        </div>
        <div className="col-12">
          <Button
            text="Agregar"
            color="green"
            fill
            action={handleAdd}
            disabled={!canAdd}
          />
        </div>
      </div>
      {!canAdd && (
        <small className="text-danger row">
          Todos los campos son obligatorios.
        </small>
      )}

      <Button
        text="Ver calendario de incapacidades"
        color="blue"
        fill
        classNames="mt-3"
        action={() => setShowCal(true)}
      />

      {/* Modal calendario */}
      {showCal && (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Calendario de Incapacidades</h5>
                <button className="btn-close" onClick={() => setShowCal(false)} />
              </div>
              <div className="modal-body">
                <FullCalendar
                  plugins={[dayGridPlugin, interactionPlugin]}
                  initialView="dayGridMonth"
                  locale={esLocale}
                  headerToolbar={{ left: 'prev,next today', center: 'title', right: '' }}
                  events={events}
                  eventClick={handleEventClick}
                  height="auto"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal edición */}
      {editing && (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content p-3">
              <div className="d-flex justify-content-between mb-3">
                <h5>Editando Incapacidad</h5>
                <button className="btn-close" onClick={() => setEditing(null)} />
              </div>
              <Input
                label="Motivo"
                value={editing.motivo}
                onChange={handleEditChange('motivo')}
              />
              <Input
                type="date"
                label="Fecha inicio"
                value={editing.fechaInicio}
                onChange={handleEditChange('fechaInicio')}
              />
              <Input
                type="date"
                label="Fecha fin"
                value={editing.fechaFin}
                onChange={handleEditChange('fechaFin')}
              />
              <Input
                label="Folio IMSS"
                value={editing.folioIMSS}
                onChange={handleEditChange('folioIMSS')}
              />
              {!canSave && (
                <small className="text-danger row">Todos los campos son obligatorios.</small>
              )}
              <div className="d-flex justify-content-end mt-3">
                <Button
                  text="Guardar"
                  color="green"
                  action={saveEdit}
                  disabled={!canSave}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
